import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { UserMoodOutput } from 'user/model/user-mood.output';

import { ApiQuery } from '../../../../common/model/api.query';

@Injectable({ providedIn: 'root' })
export class FetchLastMoodApiQuery extends ApiQuery<UserMoodOutput, void> {
	client = 'iam';
	document = gql`
		query FetchLastMood {
			fetchLastMood {
				id
				mood
				feelings
				creationTimestamp
			}
		}
	`;
	method = 'fetchLastMood';
}
